import { render, staticRenderFns } from "./CountPanel.vue?vue&type=template&id=36700b46&scoped=true"
import script from "./CountPanel.vue?vue&type=script&lang=js"
export * from "./CountPanel.vue?vue&type=script&lang=js"
import style0 from "./CountPanel.vue?vue&type=style&index=0&id=36700b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36700b46",
  null
  
)

export default component.exports